import { createSlice } from '@reduxjs/toolkit';
import { fetchMyPractices } from './MyPracticeActions';
import { getApiErrorMessage } from '../../utils/commonUtilities';

const myPracticeSlice = createSlice({
  name: 'myPractice',
  initialState: {
    data: null,
    isMyPracticesLoading: false,
    myPracticesError: null,
    myPracticesErrorMsg: ''
  },
  reducers: {
    clearErrors: (state) => {
      state.myPracticesError = null;
      state.myPracticesErrorMsg = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPractices.pending, (state) => {
        state.isMyPracticesLoading = true;
        state.myPracticesError = null;
        state.myPracticesErrorMsg = '';
      })
      .addCase(fetchMyPractices.fulfilled, (state, action) => {
        state.isMyPracticesLoading = false;
      
        
        if (action.payload && action.payload.metadata && action.payload.metadata.outcome && action.payload.metadata.outcome.status !== 200) {
          state.myPracticesError = true;
          state.myPracticesErrorMsg = getApiErrorMessage(action.payload.metadata.outcome.status);
        } else {
          state.myPracticesError = false;
        
          state.data = action.payload;
        }
      })
      .addCase(fetchMyPractices.rejected, (state) => {
        state.isMyPracticesLoading = false;
        state.myPracticesError = true;
        state.myPracticesErrorMsg = "Something Went Wrong!. Please try again later.";
    
      });
  }
});

export const { clearErrors } = myPracticeSlice.actions;
export const myPracticeReducer = myPracticeSlice.reducer;